import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuListService {

  constructor() { }

  getGlobalMenu(instanceData, roleData) {
    let menuItems = [
      {
        title: "Dashboard",
        translation_key: "dashboard",
        link: "/home",
        icon: { pack: "fas", icon: "home" },
        show: (instanceData, roleData) => {
          return !instanceData?.scaffoldType?.includes('datalink') && !instanceData?.scaffoldType?.includes('ai-detection') && !instanceData?.scaffoldType?.includes('datax');
        },
      }, {
        title: "AI Detection",
        translation_key: "ai_detection",
        link: "/ai-detection-report",
        icon: { pack: "fas", icon: "computer-classic" },
        show: (instanceData, roleData) => instanceData?.scaffoldType?.includes('ai-detection'),
      },
   /*   {
        title: "Archive",
        translation_key: "archive",
        link: "/batch-details",
        icon: { pack: "fa", icon: "container-storage" },
        show: (instanceData, roleData) => instanceData?.scaffoldType?.includes('archivev2'),
      }*/{
        title: "People",
        translation_key: "people",
        link: "/accounts",
        icon: { pack: "fa", icon: "user-graduate" },
        show: (instanceData, roleData) => instanceData?.scaffoldType?.includes('archivev2'),
      },
      {
        title: "Courses",
        link: "/courses",
        translation_key: "courses",
        icon: { pack: "fas", icon: "book-open" },
        show: (instanceData, roleData) => {
          return !instanceData?.scaffoldType?.includes('datax');
        },
      },
      {
        title: "Home",
        translation_key: "home",
        link: "/home",
        icon: { pack: "fas", icon: "home" },
        show: (instanceData, roleData) => instanceData?.scaffoldType?.includes('datax'),
      },
      {
        title: "documentation",
        translation_key: "documentation",
        link: "/documentation",
        icon: { pack: "fa", icon: "chart-network" },
        show: (instanceData, roleData) => instanceData?.scaffoldType?.includes('datax'),
      },
      {
        title: "Users & Roles",
        translation_key: "users_and_roles",
        link: "/users",
        icon: { pack: "fa", icon: "users" },
        show: (instanceData, roleData) => roleData?.manage_users,

      }
      , {
        title: "Tools",
        translation_key: "tools",
        link: "/lti",
        icon: { pack: "fas", icon: "link" },
        show: (instanceData, roleData) => {
          roleData?.manage_tools && instanceData?.scaffoldType?.includes('designer')
        },

      },
      {
        title: "Configure",
        translation_key: "configure",
        link: "/data-models",
        icon: { pack: "fas", icon: "key" },
        show: (instanceData, roleData) => roleData?.manage_views,
      },
      {
        title: "Admin",
        translation_key: "admin",
        link: "/admin",
        icon: { pack: "fas", icon: "list-alt" },
        show: (instanceData, roleData) => roleData?.view_admin,
      }
    ]
    return menuItems.filter((item) => {
      return item.show(instanceData, roleData);
    });
  }

  getMenuFooter(instanceData, roleData) {
    let footerMenu = [
            {
        icon: "fa-regular fa-hat-wizard fa-fw",
        modal: "wizard",
        title: "Wizard",
        translation_key: "wizard",
        show: (instanceData, roleData) => roleData?.view_admin && instanceData?.scaffoldType === "archivev2",
      },{
        link: "changes",
        translation_key: "changes",
        icon: "fa-regular fa-memo-circle-info",
        title: "Changes",
        show: (instanceData, roleData) => true,
      },
      {
        link: "security",
        translation_key: "security",
        icon: "fa-solid fa-shield-check",
        title: "Security",
        show: (instanceData, roleData) => true,
      },


    ];
    return footerMenu.filter((item) => {
      return item.show(instanceData, roleData);
    });
  }
}